<template>
    <div class="video-box" :style="videoStyle">
        <div ref="video"></div>
    </div>
</template>

<script>
import util from '@/common/util';
import common from '../common';

export default {
    props: {
        src: {
            type: String,
            default: ''
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
        playsinline: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            videoStyle: {}
        };
    },
    created() {
        common.prepare();
    },
    mounted() {
        this.$video = this.$refs.video;
        this.youtubeInit();
    },
    computed: {
        youtubeId() {
            return common.getYoutubeId(this.src);
        }
    },
    methods: {
        youtubeInit() {
            let bannerVideo = this.$parent.$parent.$el;
            common.prepare().then(() => {
                const playerVars = {
                    autoplay: this.autoplay ? 1 : 0,
                    controls:
                        this.controls || (util.isIos && !this.autoplay) ? 1 : 0,
                    loop: this.autoplay ? 1 : 0,
                    playsinline: 1,
                    modestbranding: 1,
                    mute: this.muted ? 1 : 0
                };

                this.youtubePlayer = new window.YT.Player(this.$video, {
                    videoId: this.youtubeId,
                    width: bannerVideo.offsetWidth,
                    height: (9 / 16) * bannerVideo.offsetWidth,
                    playerVars: playerVars,
                    events: {
                        onReady: () => {
                            if (window.innerWidth >= 1920) {
                                this.youtubePlayer.setPlaybackQuality('hd1080');
                            } else if (window.innerWidth >= 1280) {
                                this.youtubePlayer.setPlaybackQuality('hd720');
                            } else {
                                this.youtubePlayer.setPlaybackQuality(
                                    'default'
                                );
                            }
                            // (this.isAutoPlay || this.option.videoMuted) &&
                            //     this.youtubePlayer.mute();
                            this.$emit('loadedmetadata');
                            this.$emit('canplay');
                            // 视频加载完成之后，获取视频第一帧画面作为封面图
                            this.$emit(
                                'loadPreview',
                                `https://img.youtube.com/vi/${this.youtubeId}/0.jpg`
                            );

                            if (
                                util.isMobile &&
                                this.autoplay &&
                                this.youtubePlayer.playVideo
                            ) {
                                this.youtubePlayer.playVideo();
                            }
                        },
                        onStateChange: event => {
                            const playerStatus = event.data;
                            if (playerStatus === 0) {
                                if (this.autoplay) {
                                    this.youtubePlayer.playVideo();
                                } else {
                                    this.$emit('ended');
                                }
                            } else if (playerStatus === 2) {
                                this.$emit('pause');
                            } else if (playerStatus === 1) {
                                this.$emit('play');
                            }
                        },
                        onError: event => {
                            console.log('errorStatus', event.data);
                            this.$emit('error');
                        }
                    }
                });
                this.$video = this.youtubePlayer.getIframe();
            });
        },
        calcVideoStyle(option) {
            let { el, ratio, height, autoHeight, playOnPop } = option;
            let bannerVideo = el;
            let videoRatio = 9 / 16;
            if (
                (autoHeight && this.playsinline && !this.autoplay) ||
                (!playOnPop && ratio < videoRatio) ||
                (playOnPop && ratio > videoRatio)
            ) {
                this.videoStyle = {
                    height:
                        (playOnPop
                            ? window.innerWidth
                            : bannerVideo.offsetWidth) *
                            videoRatio +
                        'px',
                    width: '100%'
                };
            } else {
                this.videoStyle = {
                    width: height / videoRatio + 'px',
                    height: '100%'
                };
            }

            this.youtubePlayer.setSize &&
                this.youtubePlayer.setSize(
                    bannerVideo.offsetWidth,
                    videoRatio * bannerVideo.offsetWidth
                );

            return videoRatio;
        },
        playVideo() {
            this.youtubePlayer &&
                this.youtubePlayer.playVideo &&
                this.youtubePlayer.playVideo();
            util.timeout(() => {
                this.youtubePlayer &&
                    this.youtubePlayer.playVideo &&
                    this.youtubePlayer.playVideo();
            });
        },
        pauseVideo() {
            this.youtubePlayer.pauseVideo();
        },
        toggleMuted(muted) {
            if (muted) {
                this.youtubePlayer.mute();
            } else {
                this.youtubePlayer.unMute();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.video-box {
    position: relative;
    width: 100%;
    height: 100%;
    /deep/ iframe {
        max-width: none;
        width: 100%;
        height: 100%;
    }
}
</style>
